<template>
  <div
    v-if="visible"
    class="sidebar-backdrop"
    @click.self="close"
  >
    <div
      class="sidebar-drawer sidebar-open"
      @click.stop
    >
      <div class="sticky-header d-flex align-items-center justify-content-between">
        <div>
          <span class="ticket-ref">
            {{ request && request.order && request.order.reference ? request.order.reference : (request && request.order && request.order.id ? '#' + request.order.id : '-') }}
          </span>
          <span
            class="ml-2 status-pill"
            :class="getStatusClass(request.status)"
          >
            {{ getStatusLabel(request.status) }}
          </span>
        </div>
        <b-button
          variant="outline-secondary"
          class="btn-close-drawer"
          @click="close"
        >
          Fermer
        </b-button>
      </div>
      <div class="sidebar-content">
        <!-- Admin Response & Meta (Move to Top, Enhanced) -->
        <div class="modern-card mb-3">
          <div class="card-header-content d-flex align-items-center">
            <div
              class="header-icon-wrapper"
              style="background: #090909; color: #fff; border-radius: 8px; padding: 0.5rem;"
            >
              <i class="fas fa-ticket-alt" />
            </div>
            <strong class="ml-2">Informations de la demande</strong>
            <span class="ml-2 text-muted">#{{ request && request.id ? request.id : '-' }}</span>
          </div>
          <div class="p-3">
            <div class="row mb-2">
              <div class="col-6">
                <div class="info-item-premium">
                  <div class="info-icon-premium bg-gradient-primary">
                    <i class="fas fa-calendar-plus" />
                  </div>
                  <div class="info-content-premium">
                    <small class="text-uppercase font-weight-bold text-muted">Créée le</small>
                    <h6 class="mb-0 font-weight-bold text-primary">
                      {{ formatDate(request.created_at) }}
                    </h6>
                  </div>
                </div>
              </div>
              <div class="col-6">
                <div class="info-item-premium">
                  <div class="info-icon-premium bg-gradient-secondary">
                    <i class="fas fa-calendar-check" />
                  </div>
                  <div class="info-content-premium">
                    <small class="text-uppercase font-weight-bold text-muted">Mise à jour</small>
                    <h6 class="mb-0 font-weight-bold text-secondary">
                      {{ formatDate(request.updated_at) }}
                    </h6>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="request.accepted_at || request.rejected_at"
              class="row mb-2"
            >
              <div
                v-if="request.accepted_at"
                class="col-6"
              >
                <div class="info-item-premium">
                  <div class="info-icon-premium bg-gradient-success">
                    <i class="fas fa-check" /></div>
                  <div class="info-content-premium">
                    <small class="text-uppercase font-weight-bold text-success">Acceptée le</small>
                    <h6 class="mb-0 font-weight-bold text-success">
                      {{ formatDate(request.accepted_at) }}
                    </h6>
                  </div>
                </div>
              </div>
              <div
                v-if="request.rejected_at"
                class="col-6"
              >
                <div class="info-item-premium">
                  <div class="info-icon-premium bg-gradient-danger">
                    <i class="fas fa-times" /></div>
                  <div class="info-content-premium">
                    <small class="text-uppercase font-weight-bold text-danger">Rejetée le</small>
                    <h6 class="mb-0 font-weight-bold text-danger">
                      {{ formatDate(request.rejected_at) }}
                    </h6>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-6">
                <div class="info-item-premium">
                  <div class="info-icon-premium bg-gradient-info">
                    <i class="fas fa-info-circle" /></div>
                  <div class="info-content-premium">
                    <small class="text-uppercase font-weight-bold text-muted">Statut</small>
                    <h6 class="mb-0 font-weight-bold">
                      <span :class="'status-pill ' + getStatusClass(request.status)">{{ getStatusLabel(request.status) }}</span>
                    </h6>
                  </div>
                </div>
              </div>
              <div
                v-if="request && request.admin_response"
                class="col-6"
              >
                <div class="info-item-premium">
                  <div class="info-icon-premium bg-gradient-warning">
                    <i class="fas fa-reply" /></div>
                  <div class="info-content-premium">
                    <small class="text-uppercase font-weight-bold text-muted">Réponse admin</small>
                    <h6 class="mb-0 font-weight-bold text-warning">
                      {{ request.admin_response }}
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Order Details (Rich Layout) -->
        <div class="modern-card mb-3">
          <div class="card-header-content d-flex align-items-center">
            <div
              class="header-icon-wrapper"
              style="background: #0A2634; color: #fff; border-radius: 8px; padding: 0.5rem;"
            >
              <i class="fas fa-box" />
            </div>
            <strong class="ml-2">Commande</strong>
            <span class="ml-2 text-muted">#{{ request && request.order && request.order.id ? request.order.id : '-' }}</span>
          </div>
          <div class="p-3">
            <div class="row mb-2">
              <div class="col-6">
                <div class="info-item-premium">
                  <div class="info-icon-premium bg-gradient-indigo">
                    <i class="fas fa-user" /></div>
                  <div class="info-content-premium">
                    <small class="text-uppercase font-weight-bold text-muted">Destinataire</small>
                    <h6 class="mb-0 font-weight-bold text-indigo">
                      {{ request.order && request.order.name ? request.order.name : '-' }}
                    </h6>
                  </div>
                </div>
              </div>
              <div class="col-6">
                <div class="info-item-premium">
                  <div class="info-icon-premium bg-gradient-purple">
                    <i class="fas fa-phone" /></div>
                  <div class="info-content-premium">
                    <small class="text-uppercase font-weight-bold text-muted">Téléphone principal</small>
                    <h6 class="mb-0 font-weight-bold text-purple">
                      <span v-if="request.order && request.order.phone1">{{ request.order.phone1 }}</span>
                      <span v-if="request.order && request.order.phone2"><br>{{ request.order.phone2 }}</span>
                    </h6>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-6">
                <div class="info-item-premium">
                  <div class="info-icon-premium bg-gradient-info">
                    <i class="fas fa-map-marker-alt" /></div>
                  <div class="info-content-premium">
                    <small class="text-uppercase font-weight-bold text-muted">Gouvernorat</small>
                    <h6 class="mb-0 font-weight-bold text-info">
                      {{ request.order && request.order.governorate && request.order.governorate.name ? request.order.governorate.name : '-' }}
                    </h6>
                    <div
                      v-if="request.order && request.order.delegation && request.order.delegation.name"
                      class="text-muted"
                      style="font-size:0.95em;"
                    >
                      <i class="fas fa-map-pin mr-1" /> Délégation: {{ request.order.delegation.name }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-6">
                <div class="info-item-premium">
                  <div class="info-icon-premium bg-gradient-success">
                    <i class="fas fa-money-bill-wave" /></div>
                  <div class="info-content-premium">
                    <small class="text-uppercase font-weight-bold text-muted">Montant TTC</small>
                    <h6 class="mb-0 font-weight-bold text-success">
                      {{ request.order && request.order.price_ttc ? request.order.price_ttc + ' DT' : '-' }}
                    </h6>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-6">
                <div class="info-item-premium">
                  <div class="info-icon-premium bg-gradient-orange">
                    <i class="fas fa-warehouse" /></div>
                  <div class="info-content-premium">
                    <small class="text-uppercase font-weight-bold text-muted">Dépôt logistique</small>
                    <h6 class="mb-0 font-weight-bold text-orange">
                      {{ request.order && request.order.repository && request.order.repository.name ? request.order.repository.name : '-' }}
                    </h6>
                  </div>
                </div>
              </div>
              <div class="col-6">
                <div class="info-item-premium">
                  <div class="info-icon-premium bg-gradient-secondary">
                    <i class="fas fa-calendar-alt" /></div>
                  <div class="info-content-premium">
                    <small class="text-uppercase font-weight-bold text-muted">Date de la commande</small>
                    <h6 class="mb-0 font-weight-bold text-secondary">
                      {{ formatDate(request.order && request.order.date) }}
                    </h6>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-6">
                <div class="info-item-premium">
                  <div class="info-icon-premium bg-gradient-warning">
                    <i class="fas fa-undo" /></div>
                  <div class="info-content-premium">
                    <small class="text-uppercase font-weight-bold text-muted">Nombre de retours</small>
                    <h6 class="mb-0 font-weight-bold text-warning">
                      {{ request.order && request.order.return_number != null ? request.order.return_number : '-' }}
                    </h6>
                  </div>
                </div>
              </div>
              <div class="col-6">
                <div class="info-item-premium">
                  <div class="info-icon-premium bg-gradient-primary">
                    <i class="fas fa-info-circle" /></div>
                  <div class="info-content-premium">
                    <small class="text-uppercase font-weight-bold text-muted">Statut logistique</small>
                    <h6 class="mb-0 font-weight-bold text-primary">
                      {{ getOrderStatusLabel(request.order && request.order.status) }}
                    </h6>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mb-2">
              <div
                v-if="request.order && request.order.is_fragile"
                class="col-6"
              >
                <div
                  class="info-item-premium"
                  style="background: #fffbe6;"
                >
                  <div
                    class="info-icon-premium"
                    style="background: #ffe066;"
                  >
                    <i class="fas fa-exclamation-triangle text-warning" /></div>
                  <div class="info-content-premium">
                    <small class="text-uppercase font-weight-bold text-warning">Colis fragile</small>
                    <h6 class="mb-0 font-weight-bold text-warning">
                      <span class="badge badge-warning">OUI (Colis fragile)</span>
                    </h6>
                  </div>
                </div>
              </div>
              <div
                v-if="request.order && request.order.is_an_exchange"
                class="col-6"
              >
                <div
                  class="info-item-premium"
                  style="background: #ffeaea;"
                >
                  <div
                    class="info-icon-premium"
                    style="background: #ff6b6b;"
                  >
                    <i class="fas fa-exchange-alt text-danger" /></div>
                  <div class="info-content-premium">
                    <small class="text-uppercase font-weight-bold text-danger">Colis d'échange</small>
                    <h6 class="mb-0 font-weight-bold text-danger">
                      <span class="badge badge-danger">OUI (Colis d'échange)</span>
                    </h6>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-12">
                <div class="info-item-premium">
                  <div class="info-icon-premium bg-gradient-secondary">
                    <i class="fas fa-calendar-plus" /></div>
                  <div class="info-content-premium">
                    <small class="text-uppercase font-weight-bold text-muted">Date de création (commande)</small>
                    <h6 class="mb-0 font-weight-bold text-secondary">
                      {{ formatDate(request.order && request.order.created_at) }}
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Supplier Details (Enhanced) -->
        <div class="modern-card mb-3">
          <div class="card-header-content d-flex align-items-center">
            <div
              class="header-icon-wrapper"
              style="background: #007bff; color: #fff; border-radius: 8px; padding: 0.5rem;"
            >
              <i class="fas fa-industry" />
            </div>
            <strong class="ml-2">Fournisseur</strong>
          </div>
          <div class="p-3">
            <div class="row mb-2">
              <div class="col-6">
                <div class="info-item-premium">
                  <div class="info-icon-premium bg-gradient-indigo">
                    <i class="fas fa-user" /></div>
                  <div class="info-content-premium">
                    <small class="text-uppercase font-weight-bold text-muted">Utilisateur</small>
                    <h6 class="mb-0 font-weight-bold text-indigo">
                      {{ request.supplier && request.supplier.username ? request.supplier.username : '-' }}
                    </h6>
                  </div>
                </div>
              </div>
              <div class="col-6">
                <div class="info-item-premium">
                  <div class="info-icon-premium bg-gradient-purple">
                    <i class="fas fa-envelope" /></div>
                  <div class="info-content-premium">
                    <small class="text-uppercase font-weight-bold text-muted">Email</small>
                    <h6 class="mb-0 font-weight-bold text-purple">
                      {{ request.supplier && request.supplier.email ? request.supplier.email : '-' }}
                    </h6>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-6">
                <div class="info-item-premium">
                  <div class="info-icon-premium bg-gradient-success">
                    <i class="fas fa-phone" /></div>
                  <div class="info-content-premium">
                    <small class="text-uppercase font-weight-bold text-muted">Téléphone</small>
                    <h6 class="mb-0 font-weight-bold text-success">
                      {{ request.supplier && request.supplier.phone ? request.supplier.phone : '-' }}
                    </h6>
                  </div>
                </div>
              </div>
              <div class="col-6">
                <div class="info-item-premium">
                  <div class="info-icon-premium bg-gradient-info">
                    <i class="fas fa-map-marker-alt" /></div>
                  <div class="info-content-premium">
                    <small class="text-uppercase font-weight-bold text-muted">Adresse</small>
                    <h6 class="mb-0 font-weight-bold text-info">
                      {{ request.supplier && request.supplier.address ? request.supplier.address : '-' }}
                    </h6>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-6">
                <div class="info-item-premium">
                  <div class="info-icon-premium bg-gradient-warning">
                    <i class="fas fa-id-card" /></div>
                  <div class="info-content-premium">
                    <small class="text-uppercase font-weight-bold text-muted">Matricule fiscale</small>
                    <h6 class="mb-0 font-weight-bold text-warning">
                      {{ request.supplier && request.supplier.tax_identification_number ? request.supplier.tax_identification_number : '-' }}
                    </h6>
                  </div>
                </div>
              </div>
              <div class="col-6">
                <div class="info-item-premium">
                  <div class="info-icon-premium bg-gradient-orange">
                    <i class="fas fa-warehouse" /></div>
                  <div class="info-content-premium">
                    <small class="text-uppercase font-weight-bold text-muted">Dépôt logistique</small>
                    <h6 class="mb-0 font-weight-bold text-orange">
                      {{ request.supplier && request.supplier.repository && request.supplier.repository.name ? request.supplier.repository.name : '-' }}
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="sidebar-footer sticky-footer">
        <b-button
          variant="outline-secondary"
          class="btn-close-drawer"
          @click="close"
        >
          Fermer
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { BButton } from 'bootstrap-vue'

export default {
  name: 'RedeliveryRequestQuickView',
  components: { BButton },
  props: {
    visible: { type: Boolean, default: false },
    request: { type: Object, default: null },
  },
  methods: {
    close() {
      this.$emit('close')
    },
    getStatusClass(status) {
      if (!status) return ''
      if (status.toLowerCase() === 'pending') return 'status-open'
      if (status.toLowerCase() === 'accepted') return 'status-resolved'
      if (status.toLowerCase() === 'rejected') return 'status-closed'
      return ''
    },
    getStatusLabel(status) {
      if (!status) return '-'
      if (status.toLowerCase() === 'pending') return 'En attente'
      if (status.toLowerCase() === 'accepted') return 'Acceptée'
      if (status.toLowerCase() === 'rejected') return 'Rejetée'
      return status
    },
    formatDate(date) {
      if (!date) return '-'
      const d = new Date(date)
      if (typeof date === 'string' && date.length === 10 && date.match(/^\d{4}-\d{2}-\d{2}$/)) {
        // Only date, no time
        return d.toLocaleDateString('fr-FR')
      }
      return d.toLocaleString('fr-FR')
    },
    getOrderStatusLabel(status) {
      // You can expand this mapping as needed
      const map = {
        0: 'En attente',
        1: 'En cours de ramassage',
        2: 'Arrivé au dépôt',
        3: 'En cours d’acheminement',
        4: 'Livré au destinataire',
        5: 'Retour au dépôt logistique',
        6: 'Livré et payé',
        7: 'Retour expéditeur',
        8: 'Transfert',
        9: 'Retour payé',
        10: 'Retour inter-agence',
        11: 'Retour inter-agence reçu',
        12: 'Colis annulé par admin',
        13: 'Colis perdu',
        14: 'À vérifier',
        15: 'En attente de collecte',
        16: 'À rembourser au fournisseur',
        17: 'Remboursement effectué',
        18: 'Rendez-vous programmé',
      }
      if (status == null) return '-'
      return map[status] || status
    },
  },
}
</script>

<style scoped>
.sidebar-backdrop {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(5px);
  z-index: 2000;
}
.sidebar-drawer {
  position: fixed;
  top: 0;
  right: 0;
  width: 700px;
  height: 100%;
  background: #f8f9fa;
  box-shadow: -2px 0 18px rgba(0, 0, 0, 0.18);
  transform: translateX(100%);
  transition: transform 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  z-index: 2100;
  display: flex;
  flex-direction: column;
  border-radius: 18px 0 0 18px;
}
.sidebar-open {
  transform: translateX(0);
}
.sticky-header {
  position: sticky;
  top: 0;
  z-index: 2;
  background: linear-gradient(90deg, #0A2634 0%, #090909 100%);
  color: #fff;
  border-radius: 18px 0 0 0;
  padding: 1.25rem 1.5rem;
  min-height: 70px;
  box-shadow: 0 2px 8px rgba(102,126,234,0.08);
}
.btn-close-drawer {
  min-width: 120px;
  font-weight: 600;
  border-radius: 8px;
  transition: background 0.2s;
}
.btn-close-drawer:hover {
  background: #e2e8f0;
  color: #333;
}
.sidebar-content {
  flex: 1;
  overflow-y: auto;
  padding: 2rem 1.5rem 1.5rem 1.5rem;
  background: #f8f9fa;
}
.sidebar-footer {
  padding: 1.25rem 1.5rem;
  border-top: 1px solid #e9ecef;
  background: #fff;
  border-radius: 0 0 0 18px;
  display: flex;
  justify-content: flex-end;
}
.sticky-footer {
  position: sticky;
  bottom: 0;
  z-index: 2;
  background: #fff;
}
.ticket-ref {
  font-size: 1.18rem;
  font-weight: 700;
  letter-spacing: 1px;
}
.status-pill {
  font-size: 1.05rem;
  font-weight: 700;
  padding: 0.3em 0.8em;
  border-radius: 8px;
  text-transform: uppercase;
  margin-left: 0.5rem;
}
.status-open {
  background: #ffeaea;
  color: #0A2634;
}
.status-resolved {
  background: #e6f9ed;
  color: #28a745;
}
.status-closed {
  background: #f8d7da;
  color: #dc3545;
}
</style>
